import React from 'react';
import { Link } from 'react-router-dom';

const FloatingInfoButton: React.FC = () => {
  return (
    <Link
      to="/flugplatzinfo"
      className="fixed bottom-5 right-5 z-40 grid h-12 w-12 place-items-center bg-blue-600 text-white shadow-lg transition-colors hover:bg-blue-700 hover:text-white"
      aria-label="Flugplatzinformationen"
    >
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </Link>
  );
};

export default FloatingInfoButton;
